import axios from 'axios';
import { useEffect, useState } from 'react';

const storageKeys = {
	region: 'visitorRegion',
	country: 'visitorCountry',
};

const getParam = (key) => {
	try {
		const url = new URL(window.location);
		return url.searchParams.get(key)?.toLowerCase() || '';
	} catch {
		return '';
	}
};

export const useLocation = (regionUrl) => {
	const [region, setRegion] = useState(getParam('region') || localStorage.getItem(storageKeys.region) || '');
	const [country, setCountry] = useState(getParam('country') || localStorage.getItem(storageKeys.country) || '');

	useEffect(() => {
		if (!regionUrl) return;
		if (region && country) return;

		let cancelled = false;

		const fetchLocation = async () => {
			try {
				const { data } = await axios.get(regionUrl);

				if (!cancelled) {
					setRegion(data.region.toLowerCase());
					setCountry(data.country.toLowerCase());
				}
			} catch {
				if (!cancelled) {
					setRegion('');
					setCountry('');
				}
			}
		};

		fetchLocation();

		return () => {
			cancelled = true;
		};
	}, [regionUrl]);

	// Store region and country in localStorage whenever they change
	useEffect(() => {
		region && localStorage.setItem(storageKeys.region, region);
		country && localStorage.setItem(storageKeys.country, country);
	}, [region, country]);

	return { region, country };
};
